import { ENERGY, EXPANSION_NAMES, POKEMON, TRAINER } from '../constants';

/** The kinds of card to filter by. */
export const KINDS = { pokemon: POKEMON, trainer: TRAINER, energy: ENERGY };

const SET_ORDER = Object.keys(EXPANSION_NAMES);
const isKind = (card, kind) => card.get('cardTypes').some(type => type.get('id') === kind);

/**
 * The cards matching a lookup, in set order and then by number: by name or attack text (`query`, any case), set,
 * kind, and whether only playable ones.
 *
 * @param {Map} cardsById every card
 * @param {{ query: string, set: string, kind: string, playableOnly: boolean }} filters set and kind '' for any
 * @returns {Map[]}
 */
export function filterCards(cardsById, { query = '', set = '', kind = '', playableOnly = false }) {
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const text = (card) => [card.get('name'), card.get('rules_text'), ...(card.get('moves') || []).map(move => move.get('name'))]
    .filter(Boolean).join(' ').toLowerCase();

  return cardsById.valueSeq()
    .filter(card => !set || card.get('expansion_id') === set)
    .filter(card => !kind || isKind(card, KINDS[kind]))
    .filter(card => !playableOnly || card.get('enabled') !== false)
    .filter(card => words.every(word => text(card).includes(word)))
    .sort((a, b) => (SET_ORDER.indexOf(a.get('expansion_id')) - SET_ORDER.indexOf(b.get('expansion_id')))
      || (Number(a.get('card_number')) - Number(b.get('card_number'))))
    .toArray();
}
